module.exports = __webpack_public_path__ + "static/media/Jennifer Case Headshot.b774c8f8.jpeg";